export enum Categories {
  Partnerships = 'partnerships',
  Authentication = 'authentication',
  Login = 'login',
  Recovery = 'recovery',
  NewPassword = 'newpassword',
}

export enum Actions {
  ButtonCta = 'button cta',
  LinkCta = 'link cta',
  Login = 'login',
  Submit = 'submit',
}

export enum Labels {
  Error = 'error',
  Success = 'success',
}

export enum EventName {
  Partners = 'partners_portal_event',
  PageView = 'partners_portal_pageview',
}
